import React from "react";
import { styled } from "styled-components";
import Typewriter from "typewriter-effect";
import { BiSolidChevronRight } from "react-icons/bi";

import { HomeNavigation } from "../../components/Navbar";
import emoji from "../../assets/images/emoji.png";
import AnimatedContent from "../../utility/animated";
import DecryptedText from "../../utility/decrypt";



export default function Home() {
  const disableImage = (event) => event.preventDefault();
  return (
    <Container id="home">
      <HomeNavigation />
      <div className="home-wrapper">
        <div className="details">
          <h1>👋
              <div style={{ marginTop: '0rem', display:'inline', marginLeft:'2px' }}>
              <DecryptedText
                text="Hello, I'm Mohammed Amaan Ahmed Khan!"
              speed={90}
              sequential
              className="revealed"
              useOriginalCharsOnly
              maxIterations={10}
                animateOn="view"
                revealDirection="start"
              />
              </div>
             </h1>
          <Typewriter
            options={{
              strings: ["AI Enthusiast", "Ex-Software Engineer - II @Verizon", "Full stack Developer"],
              autoStart: true,
              loop: true,
            }}
          />
        </div>

        <div className="emoji">
        <AnimatedContent
          distance={150}
          direction="horizontal"
          reverse={false}
          duration={2.6}
          ease="elastic.out(1,0.3)"
          initialOpacity={0}
          animateOpacity
          scale={0.5}
          threshold={0.2}
          delay={0.6}
        >
          <div className="emoji-img">
            <img
              src={emoji}
              alt="emoji"
              onContextMenu={disableImage}
              onDragStart={disableImage}
            />
          </div>
        </AnimatedContent>

          <div className="my-status">
            <p>
              <BiSolidChevronRight />
              amaan@workspace <span>~</span> <span>status</span> <span className="blink_me"></span>
            </p>
            <p>
          

              I love the “figure it out” part of tech the moment something breaks, and I refuse to stop until it makes sense and works the right way. That mindset pulled me into software, and now into building AI/ML systems that don’t just look good in a notebook but also hold up in the real world.

I’m big on sports and naturally adventurous, so I’m wired for competition, momentum, and pushing limits. I bring that same energy to building: move fast, learn fast, and turn ideas into something real prototype it, build it, ship it, then level it up.

Right now I’m focused on LLM apps, predictive modeling, and computer vision. I also enjoy the full-stack side of bringing these ideas to life from backend APIs and data flows to clean, usable front-ends. Working on SSO/IAM showed me that reliability isn’t optional when identity breaks, everything breaks so I design systems to be stable, auditable, and dependable.
            </p>
          </div>
        </div>
      </div>
    </Container>
  );
}

const Container = styled.div`
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;


  .blink_me {
  animation: blinker 2.5s linear infinite;
  width: 10px;
  margin-left: 5px;
  height: 10px;
  display: inline-block;
  border: 1px solid green;
  background-color: green;
  border-radius: 100%;
}
@keyframes blinker {
  50% {
    opacity: 0.3;
  }
}
  

  .home-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    flex: 1;
    min-height: 0;
    font-family: "Poppins", sans-serif;

    .details {
      width: 60%;
      user-select: none;
      h1 {
        font-weight: 500;
        font-size: 28px;
        color: #1c1d20;
      }
      .Typewriter {
        min-height: 160px;
      }
      .Typewriter span {
        font-weight: 500;
        font-size: 52px;
        color: #1c1d20;
      }
      .Typewriter__cursor {
        font-weight: 300 !important;
      }
    }

    .emoji {
      flex-shrink: 0;
      width: 40%;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 30px;

      .emoji-img {
        width: 100%;
        max-width: 320px;
        aspect-ratio: 1/1;
        img {
          width: 100%;
        }
      }

      .my-status {
        padding: 20px 26px;
        border-radius: 10px;
        border: 1px solid #1c1d20;
        width: 100%;
        max-width: 460px;

        p {
          user-select: none;

          &:first-child {
            display: flex;
            align-items: center;
            color: #7021ed;
            font-weight: 500;
            font-size: 14px;
            letter-spacing: 1px;

            span:first-of-type {
              color: #1c1d20;
              margin: 0 5px;
              font-size: 18px !important;
            }
            span:last-of-type {
              color: #1581ef;
            }

            svg {
              font-size: 18px;
              margin-right: 1px;
            }
          }
          &:last-child {
            padding: 1px 0 0 5px;
            font-size: 13px;
            color: #1c1d20;
            line-height: 21px;
          }
        }
      }
    }
  }
  @media (max-width: 768px) {
    .home-wrapper {
      flex-direction: column;
      flex: 0;

      .details {
        width: 100%;
        margin-top: 160px;

        h1 {
          font-size: 22px;
        }
        .Typewriter span {
          font-size: 38px;
        }
      }

      .emoji {
        margin-top: 0px;
        align-items: center;
        width: 100%;
      }
      .my-status {
        margin-top: 30px;
      }
    }
  }
`;
